import Uppy from '@uppy/core'
// import AwsS3Multipart from '@uppy/aws-s3-multipart'
import AwsS3 from '@uppy/aws-s3';
import store from "~/store";

const handleUploadSuccess = (file, response) => {
  console.log(
    `%cEPC-TACKER: %c file ${file.name} subido correctamente`,
    'background: #5577BB; color: #fff',
    'color: #fff'
  )
}

const handleUploadProgress = (file, progress) => {
  const percent = Math.round((progress.bytesUploaded * 100) / progress.bytesTotal);
  console.log(
    `%cEPC-TACKER: %c progreso del archivo ${file.name}: ${percent}%`,
    'background: #5577BB; color: #fff',
    'color: #fff'
  );
}

const handleUploadError = (file, error, response) => {
  console.error(
    `%cEPC-TACKER: %c Ha ocurrido un error al subir el archivo ${file.data.name}`,
    'background: #5577BB; color: #fff',
    'color: #fff',
    error
  )
}

const createUppyInstance = ({ onSuccess, onProgress, onError } = {}) => {
  const uppy = new Uppy({
    debug: process.env.NODE_ENV === 'development',
    autoProceed: false,
    allowMultipleUploads: false,
  });

  uppy.use(AwsS3, {
    shouldUseMultipart: true,
    limit: 3,
    companionUrl: '/api/v2/',
    endpoint: '/api/v2/',
    headers: {
      'Authorization': "Bearer " + store.getters["auth/token"]
    }
  });

  if (typeof onSuccess === 'function') {
    uppy.on('upload-success', onSuccess);
  } else {
    uppy.on('upload-success', handleUploadSuccess);
  }

  if (typeof onProgress === 'function') {
    uppy.on('upload-progress', onProgress);
  } else {
    uppy.on('upload-progress', handleUploadProgress);
  }

  if (typeof onError === 'function') {
    uppy.on('upload-error', onError);
  } else {
    uppy.on('upload-error', handleUploadError);
  }

  return {
    uppy,
    close: () => { uppy.destroy() }
  };
}

const uploadFile = (file) => {
  return new Promise((resolve, reject) => {
    const { uppy, close } = createUppyInstance({
      onSuccess: (file, response) => {
        resolve({ file, response });
        close(); // muy importante para liberar recursos
      },
      onError: (file, error) => {
        reject(error);
        close();
      }
    });

    if (!file || !file.name || !file.type) {
      return reject(new Error('Archivo inválido'));
    }

    uppy.addFile({
      name: file.name,
      type: file.type,
      data: file,
    });

    uppy.upload().catch(reject);
  });
}

export {
  createUppyInstance,
  uploadFile,
}

export default {
  createUppyInstance,
  uploadFile,
};
